import React from 'react';

import Image from '../../../../library/image/image';

import './unstuddable-image.scss';

function UnstuddableImage() {
  return (
    <Image
      alt="Unstuddable"
      height="24"
      src="https://discounttire.scene7.com/is/content/discounttire/logos/icons/feature-icon_unstuddable-tire.svg"
      styleName="unstuddable-image"
      width="24"
    />
  );
}

export default UnstuddableImage;
